const getUrlParams = function() {
  const query = window.location.search.substring(1);
  const raw_vars = query.split("&");

  const params = {};

  for (let v of Array.from(raw_vars)) {
    const [key, val] = Array.from(v.split("="));
    if (key.length > 0) { params[key] = decodeURIComponent(val); }
  }

  return params;
};

$(document).on("click", "a.click-disabled", function(e) {
  e.preventDefault();
});

$(document).on("click", "[data-action='notify-owner']", function(e) {
  e.preventDefault();
  const btn = $(this);
  const calendarId = btn.data("calendar-id");
  if (!calendarId) return;

  btn.hide();
  const threshold = btn.data("usage-threshold") || "100";
  $.post(`/calendars/${calendarId}/notify_ai_usage_limit`, { usage_threshold: threshold })
    .done(() => {
      const dismissTarget = btn.closest(".ai-usage-banner, .loomly-ai-sidebar-offer");
      if (dismissTarget.length) {
        if (dismissTarget.hasClass("ai-usage-banner")) document.cookie = "ai_banner_dismissed=1;path=/;SameSite=Lax";
        dismissTarget.fadeOut(300, () => dismissTarget.remove());
      }
    })
    .fail((xhr) => {
      if (xhr.status === 429) {
        const dismissTarget = btn.closest(".ai-usage-banner, .loomly-ai-sidebar-offer");
        if (dismissTarget.length) {
          if (dismissTarget.hasClass("ai-usage-banner")) document.cookie = "ai_banner_dismissed=1;path=/;SameSite=Lax";
          dismissTarget.fadeOut(300, () => dismissTarget.remove());
        }
      } else {
        btn.show();
        alert("Something went wrong. Please try again.");
      }
    });
});

$(document).on("turbo:load", ()=> {

  // After a panel expands, the window will scroll to the top of the now opened panel
  $(".panel-scroll-to").on("shown.bs.collapse", function(e) {
    const $panel = $(this).closest(".panel");

    $("html,body").animate({
      scrollTop: $panel.offset().top
    }, 500);
  });


  // Ability to auto show/promote a feature that may not be immediately obvious
  // via a url param
  const auto_shown_feature = getUrlParams()["auto_show_feature"];

  if (auto_shown_feature) {
    switch (auto_shown_feature) {
      case "notify_collaborator":
        $(".show-notify-collaborator-modal").first().click();
        break;
      case "pdf_export":
        $(".show-export-content-modal").first().click();
        break;
    }
  }

  $(document).on("click", "a.click-disabled", function(e) {
    e.preventDefault();
  });

  $(document).on("click", "[data-action='notify-owner']", function(e) {
    e.preventDefault();
    const btn = $(this);
    const calendarId = btn.data("calendar-id");
    if (!calendarId) return;

    btn.hide();
    const threshold = btn.data("usage-threshold") || "100";
    $.post(`/calendars/${calendarId}/notify_ai_usage_limit`, { usage_threshold: threshold })
      .done(() => {
        const dismissTarget = btn.closest(".ai-usage-banner, .loomly-ai-sidebar-offer");
        if (dismissTarget.length) {
          if (dismissTarget.hasClass("ai-usage-banner")) document.cookie = "ai_banner_dismissed=1;path=/;SameSite=Lax";
          dismissTarget.fadeOut(300, () => dismissTarget.remove());
        }
      })
      .fail((xhr) => {
        if (xhr.status === 429) {
          const dismissTarget = btn.closest(".ai-usage-banner, .loomly-ai-sidebar-offer");
          if (dismissTarget.length) {
            if (dismissTarget.hasClass("ai-usage-banner")) document.cookie = "ai_banner_dismissed=1;path=/;SameSite=Lax";
            dismissTarget.fadeOut(300, () => dismissTarget.remove());
          }
        } else {
          btn.show();
          alert("Something went wrong. Please try again.");
        }
      });
  });
});
